// atoms.ts
import { atom, useAtom } from 'jotai'

import { isSuccess } from '@/axios'

import { loginStateAtom } from './user'
import { store } from '.'
import { checkRewardsNoReceived, ICheckRewardsNoReceivedResponse } from '@/api'

export const unclaimedRewardsAtom = atom<ICheckRewardsNoReceivedResponse>({
  no_received_task: false,
  no_received_task_daily: false,
  no_received_task_weekly: false,
})
unclaimedRewardsAtom.debugLabel = 'unclaimedRewardsAtom'

export const useUnclaimedRewardsAtom = () => {
  const [unclaimedRewards, setUnclaimedRewards] = useAtom(unclaimedRewardsAtom)

  return {
    unclaimedRewards,
    setUnclaimedRewards,
  }
}

export const handleCheckRewardsNoReceived = () => {
  const isLogin = store.get(loginStateAtom)
  if (!isLogin) {
    return
  }
  if (location.pathname.includes('/writing')) {
    return
  }
  checkRewardsNoReceived().then((resp) => {
    if (isSuccess(resp)) {
      store.set(unclaimedRewardsAtom, resp.data)
    }
  })
}
